module.exports = __webpack_public_path__ + "media/40ece22385f34c50b21380953a6ec8e9.0f008f4a.mp4";